import styled, { css } from "styled-components";
import { StyledButton, UnStyledButton } from "../button/button.styles";

const modalButtonOverwrites = css`
  font-size: 15px;
`;

export const ModalButton = styled(StyledButton)`
  ${modalButtonOverwrites}
`;

export const OutlineModalButton = styled(UnStyledButton)`
  ${modalButtonOverwrites}
`
